/* eslint-disable max-len */
const en_US = {
  cart: {
    addedToBag: "Added to your bag",
    checkout: "Checkout",
    primaryCta: "View Bag & Checkout",
    secondaryLink: "Continue Shopping",
    size: "Size",
    subtotal: "Subtotal",
    viewBag: "View Bag",
    addToCartModal: {
      selectedItemMessage: {
        pis: "Order before 5pm and pick up today",
        nonReturnable: {
          tooltipText: "Final Sale",
          tooltipMessage:
            "This item is final sale. No returns or exchanges allowed on this item.",
          signInReminderText:
            "Members can return for credit. Sign in during checkout.",
        },
        default: "Free Shipping + Free returns",
      },
      lsnMessage: "Only a few left!",
      modalTitles: [
        "You've got great taste",
        "Nice pick!",
        "Expect compliments",
        "We love it too",
      ],
    },
  },
  cdp: {
    results: "items",
    sort: {
      desktop: "Sort by",
      mobile: "Sort",
    },
    filters: "Filters",
    seo: {
      copyright: {
        key: "copyright",
        value: "lululemon athletica",
      },
      canonical: {
        key: "canonical",
      },
      description: {
        key: "description",
      },
    },
  },
  error: {
    fallback: "Sorry, we're having a moment.",
    help: {
      header: "How can we help?",
      text: "Use the search box to find what you're looking for.",
    },
    search: {
      button: "SEARCH",
      input: "Type to search",
    },
    messages: {
      timeout: {
        code: 504,
        message: "Your request timed out. Please try again later.",
        title: "Oops",
      },
    },
  },
  featuredProduct: {
    colors: "Available in * colors",
  },
  footer: {
    copyright: "© lululemon athletica",
    countrySelector: {
      confirmation:
        "Are you sure you want to change sites? You won't be able to access your items in your cart on the new country/region site.",
      placeholder: "Type in your country/region",
    },
    preferences: "MY SHOP PREFERENCES",
  },
  home: {
    seo: {
      description:
        "lululemon activewear, loungewear and footwear for all the ways you love to move. Sweat, grow & connect in performance apparel.",
      copyright: "lululemon athletica",
      canonical: "https://shop.lululemon.com",
      title: "technical apparel + athletic shoes | lululemon",
      languageContent: "english",
      hreflang: [
        {
          rel: "alternate",
          hreflang: "en-US",
          href: "https://shop.lululemon.com",
        },
        {
          rel: "alternate",
          hreflang: "en-CA",
          href: "https://shop.lululemon.com",
        },
        {
          rel: "alternate",
          hreflang: "fr-CA",
          href: "https://shop.lululemon.com",
        },
        {
          rel: "alternate",
          hreflang: "en-AU",
          href: "https://www.lululemon.com.au/en-au/home",
        },
        {
          rel: "alternate",
          hreflang: "en-FR",
          href: "https://www.lululemon.fr/en-fr/home",
        },
        {
          rel: "alternate",
          hreflang: "ja-JP",
          href: "https://www.lululemon.co.jp/ja-jp/home",
        },
        {
          rel: "alternate",
          hreflang: "en-NZ",
          href: "https://www.lululemon.co.nz/en-nz/home",
        },
        {
          rel: "alternate",
          hreflang: "en-GB",
          href: "https://www.lululemon.co.uk/en-gb/home",
        },
        {
          rel: "alternate",
          hreflang: "en-HK",
          href: "https://www.lululemon.com.hk/en-hk/home",
        },
        {
          rel: "alternate",
          hreflang: "en-CH",
          href: "https://www.eu.lululemon.com/en-ch/home",
        },
        {
          rel: "alternate",
          hreflang: "en-DE",
          href: "https://www.lululemon.de/en-de/home",
        },
        {
          rel: "alternate",
          hreflang: "fr-FR",
          href: "https://www.lululemon.fr/fr-fr/home",
        },
        {
          rel: "alternate",
          hreflang: "de-DE",
          href: "https://www.lululemon.de/de-de/home",
        },
        {
          rel: "alternate",
          hreflang: "es-ES",
          href: "https://www.lululemon.es/es-es/home",
        },
        {
          rel: "alternate",
          hreflang: "de-CH",
          href: "https://www.eu.lululemon.com/de-ch/home",
        },
        {
          rel: "alternate",
          hreflang: "fr-CH",
          href: "https://www.eu.lululemon.com/fr-ch/home",
        },
        {
          rel: "alternate",
          hreflang: "en-LU",
          href: "https://www.eu.lululemon.com/en-lu/home",
        },
        {
          rel: "alternate",
          hreflang: "de-LU",
          href: "https://www.eu.lululemon.com/de-lu/home",
        },
        {
          rel: "alternate",
          hreflang: "fr-LU",
          href: "https://www.eu.lululemon.com/fr-lu/home",
        },
        {
          rel: "alternate",
          hreflang: "ko-KR",
          href: "https://www.lululemon.co.kr/ko-kr/home",
        },
        {
          rel: "alternate",
          hreflang: "en-IE",
          href: "https://www.eu.lululemon.com/en-lu/home",
        },
        {
          rel: "alternate",
          hreflang: "en-SE",
          href: "https://www.eu.lululemon.com/en-lu/home",
        },
        {
          rel: "alternate",
          hreflang: "en-NL",
          href: "https://www.eu.lululemon.com/en-lu/home",
        },
        {
          rel: "alternate",
          hreflang: "en-AE",
          href: "https://www.lululemon.me/en-ae",
        },
        {
          rel: "alternate",
          hreflang: "en-SA",
          href: "https://www.lululemon.me/en-sa",
        },
        {
          rel: "alternate",
          hreflang: "zh-HK",
          href: "https://www.lululemon.com.hk/zh-hk/home",
        },
        {
          rel: "alternate",
          hreflang: "en-KW",
          href: "https://www.lululemon.me/en-kw",
        },
        {
          rel: "alternate",
          hreflang: "en-QA",
          href: "https://www.lululemon.me/en-qa",
        },
        {
          rel: "alternate",
          hreflang: "ar-QA",
          href: "https://www.lululemon.me/ar-qa",
        },
        {
          rel: "alternate",
          hreflang: "ar-SA",
          href: "https://www.lululemon.me/ar-sa",
        },
        {
          rel: "alternate",
          hreflang: "zh-TW",
          href: "https://www.lululemon.com.hk/zh-hk/home",
        },
        {
          rel: "alternate",
          hreflang: "en-TW",
          href: "https://www.lululemon.com.hk/en-hk/home",
        },
        {
          rel: "alternate",
          hreflang: "en-SG",
          href: "https://www.lululemon.com.hk/en-sg/home",
        },
        {
          rel: "alternate",
          hreflang: "x-default",
          href: "https://shop.lululemon.com",
        },
      ],
    },
  },
  megaNav: {
    greeting: "HI",
    signin: "SIGN IN",
  },
  search: {
    city: "city",
    chat: "chat",
    country: "country",
    defaultTitle: "All Products",
    noResults: "Sorry, no results were found for",
    showMore: "show more",
    suggestions: {
      title: "Search Suggestions",
      tryAgain: "Try another search",
      spelling: "Check your spelling",
      simplify: "Try more general words",
      later: "You can always narrow your search results later",
    },
  },
  story: {},
  pdp: {
    buttons: {
      chat: "Live Chat",
      reviews: "Reviews",
      share: "Share",
    },
    seo: {
      copyright: {
        value: "lululemon athletica",
        key: "copyright",
      },
      canonical: {
        key: "canonical",
      },
      description: {
        key: "description",
      },
      ogTags: {
        imageWidth: "415",
        imageHeight: "498",
        appId: "123373097768859",
        siteName: "lululemon",
        type: "product",
      },
    },
    labels: {
      selectSize: "Select Size",
      selectWaist: "Select Waist",
      size: "Size",
      waist: "Waist",
      sizeGuide: "Size guide",
      whyWeMadeThis: "Why we made this",
      youMayAlsoLike: "You may also like",
    },
    purchaseMethod: {
      shippingAndReturn: "Free shipping + Members can return for credit",
    },
    hazmatShippingWarning:
      "Shipping restrictions: This product can only ship via standard ground. Therefore, you will be unable to select the priority shipping option or receive products in Hawaii, Alaska & Puerto Rico.",
  },
  outOfStock: {
    buttonTextLeft: "Shop Women",
    buttonTextRight: "Shop Men",
    headline: "Oh snap! Looks like we’re all out",
    leftImageAlt: "Woman",
    rightImageAlt: "Man",
    shopByGenderTitle: "Don’t sweat it. We have more gear that you’ll love.",
  },
};

export default en_US;
